import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PolicyPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadPage() {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get(`/pages/${slug}`);
        setPage(res.data);
        // Update document title
        document.title = res.data.metaTitle || res.data.title;
      } catch (err) {
        if (err.response?.status === 404) {
          setError("Page not found");
        } else {
          setError("Failed to load page");
        }
      } finally {
        setLoading(false);
      }
    }
    loadPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
        <h1 className="text-2xl font-bold">{error}</h1>
        <Link to="/" className="text-primary hover:underline">
          Go back home
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
        <Link to="/" className="hover:text-foreground transition-colors">
          Home
        </Link>
        <ChevronRight className="w-4 h-4" />
        <span className="text-foreground">{page.title}</span>
      </nav>

      {/* Page Content */}
      <article className="prose prose-neutral max-w-none">
        <h1 className="text-3xl font-bold mb-8">{page.title}</h1>
        <div
          className="policy-content"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </article>

      {/* Last updated */}
      {page.updatedAt && (
        <div className="mt-12 pt-6 border-t border-border text-sm text-muted-foreground">
          Last updated:{" "}
          {new Date(page.updatedAt).toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>
      )}
    </div>
  );
}
